import request from "@/utils/request";


/**
 * 商品添加
 *
 */
export function goodAdd(data) {
    return request({
        url: '/api/selection_library/guide_store/goods/add',
        method: 'POST',
        data
    })
}


/**
 * 商品列表
 *
 */
export function fetchGoodData(data) {
    return request({
        url: '/api/selection_library/guide_store/goods/list',
        method: 'POST',
        data
    })
}

/**
 * 商品统计
 *
 */
export function goodCount(data) {
    return request({
        url: '/api/selection_library/guide_store/goods/total',
        method: 'POST',
        data
    })
}


/**
 * 商品删除
 *
 */
export function goodDel(data) {
    return request({
        url: '/api/selection_library/guide_store/goods/del',
        method: 'POST',
        data
    })
}


/**
 * 商品提交审核
 *
 */
export function goodSubmitProcess(data) {
    return request({
        url: '/api/selection_library/guide_store/goods/audit',
        method: 'POST',
        data
    })
}

/**
 * 商品提交审核
 *
 */
export function goodSubmitProductUp(data) {
    return request({
        url: '/api/selection_library/guide_store/goods/up',
        method: 'POST',
        data
    })
}
export function goodSubmitProductUpdate(data) {
    return request({
        url: '/api/selection_library/guide_store/goods/update',
        method: 'POST',
        data
    })
}

/**
 * 商品提交审核时的计算支付积分
 *
 */
export function computedIntegral(data) {
    return request({
        url: '/api/selection_library/guide_store/goods/cale',
        method: 'POST',
        data
    })
}


/**
 * 商品提交审核时的计算支付积分
 *
 */
export function computedIntegralNew(data) {
    return request({
        url: '/api/selection_library/guide_store/goods/new_cale',
        method: 'POST',
        data
    })
}



/**
 * 商品上下架
 *
 */
export function goodGrounding(data) {
    return request({
        url: '/api/selection_library/guide_store/goods/down',
        method: 'POST',
        data
    })
}


/**
 * 规则
 */
export function fetchRule() {
    return request({
        url: '/api/selection_library/guide_store/base',
        method: 'get'
    })
}



/**
 * 积分充值基本信息
 */
export function integralBaseInfo() {
    return request({
        url: '/api/selection_library/guide_store/recharge/base',
        method: 'get'
    })
}



/**
 * 充值操作
 */
export function recharge(data) {
    return request({
        url: '/api/selection_library/guide_store/recharge/doing',
        method: 'POST',
        data
    })
}



/**
 * 计算充值手续费
 */
export function computedCommission(data) {
    return request({
        url: '/api/selection_library/guide_store/recharge/cale',
        method: 'POST',
        data
    })
}





/**
 * 批量提交审核计算价格
 *
 */
export function batchComputedIntegral(data) {
    return request({
        url: '/api/selection_library/guide_store/goods/more_cale',
        method: 'POST',
        data
    })
}

/**
 * 商品批量提交审核
 *
 */
export function batchSubmitProcess(data) {
    return request({
        url: '/api/selection_library/guide_store/goods/more_audit',
        method: 'POST',
        data
    })
}





/**
 * 充值记录
 */
export function rechargeRecord(data) {
    return request({
        url: '/api/selection_library/guide_store/recharge/list',
        method: 'POST',
        data
    })
}



/**
 * 充值统计
 */
export function rechargeData(data) {
    return request({
        url: '/api/selection_library/guide_store/recharge/total',
        method: 'POST',
        data
    })
}




/**
 * 订单列表
 */
export function fetchOrderList(data) {
    return request({
        url: '/api/selection_library/guide_store/order/list',
        method: 'POST',
        data
    })
}



/**
 * 订单统计
 */
export function fetchOrderData(data) {
    return request({
        url: '/api/selection_library/guide_store/order/total',
        method: 'POST',
        data
    })
}
